import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from "../../utils/axiosInstance";
import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const CarrierPackageSelect = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const getDeviceId = () => {
        let id = localStorage.getItem('deviceId');
        if (!id) {
            id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
            localStorage.setItem('deviceId', id);
        }
        return id;
    };


    const handleLogin = async () => {
        setError('');
        const deviceId = getDeviceId();

        try {
            const res = await api.post('/carriers/login', {
                ...form,
                deviceId,
            });

            if (res.data.success && res.data.user?._id && res.data.token) {
                localStorage.setItem(
                    'carrierUser',
                    JSON.stringify({
                        _id: res.data.user._id,
                        token: res.data.token,
                        deviceId,
                    })
                );

                api.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;

                navigate('/carrier/package');
            } else {
                setError(res.data.message || 'Login failed');
                localStorage.removeItem('carrierUser');
                delete api.defaults.headers.common['Authorization'];
            }
        } catch (err) {
            const msg = err.response?.data?.message || 'Login failed';
            console.error('Login Error:', msg);

            setError(msg);
            localStorage.removeItem('carrierUser');
            delete api.defaults.headers.common['Authorization'];
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col font-oswald">
            <HeaderBlue />

            <section
                className="w-full py-60 relative"
                style={{
                    backgroundImage: "url('./assets/employer.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10"></div>
            </section>

            <div className="flex items-center justify-center p-4 -mt-40 relative z-10 mb-10">
                <div className="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-300 bg-white/85 backdrop-blur-md">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-primary mb-2">CARRIER LOGIN</h1>
                        <p className="text-gray-600">If you are not registered, then register to purchase the package</p>
                    </div>

                    <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter your email"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <input
                                type="password"
                                name="password"
                                value={form.password}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter your password"
                                required
                            />
                        </div>

                        {error && <div className="text-blue-600 text-sm">{error}</div>}

                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    className="h-4 w-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                                />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">Remember me</label>
                            </div>
                            <div className="text-sm">
                                <a href="/ForgotPassword" className="font-medium text-secondary hover:text-black">
                                    Forgot password?
                                </a>
                            </div>
                        </div>
                        <div className="flex items-center justify-center mt-2 mb-8">
                            <button
                                onClick={() => navigate('/carrier-registration')}
                                className="text-sm text-secondary px-3 py-2 font-semibold hover:underline hover:text-black transition"
                            >
                                Not yet registered?{' '}
                                <span className="text-base font-bold">REGISTER NOW!</span>
                            </button>

                        </div>
                        <div>
                            <button
                                type="submit"
                                onClick={handleLogin}
                                className="w-full bg-secondary text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition"
                            >
                                LOG IN
                            </button>
                        </div>
                    </form>

                    <div className="mt-6 text-center text-sm">
                        <p className="text-gray-600">
                            By logging into your account, you agree to our
                            <a href="#" className="text-secondary font-medium"> Terms of Use </a> and
                            <a href="#" className="text-secondary font-medium"> Privacy Policy</a>,
                            and to the use of cookies as described therein.
                        </p>
                    </div>
                </div>
            </div>


            <FooterBlue />
        </div>
    );
};

export default CarrierPackageSelect;
